import { createReducer } from "@reduxjs/toolkit";


export const paymentReducer = createReducer({}, {
    setBillingInfo: (state, action) => {
        state.billingInfo = action.payload.data;
    },
    
})  